export default "__VITE_ASSET__DxUm5u$9__"